import '../stylesheets/application.css'
import '@fortawesome/fontawesome-free/css/all.min.css'

import { createApp } from 'vue'
import { createPinia } from 'pinia'
import Goll from '../goll.vue'

document.addEventListener('DOMContentLoaded', () => {
  const app = createApp({})
  app.component('goll', Goll)
  app.use(createPinia())
  app.mount('[data-behavior="vue"]')
})
